import React, { createElement } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { useT } from '../utils/i18n';
import { CredentialsBar } from './CredentialsBar';
export function Footer() {
  const t = useT();
  return <footer className="pt-12 border-t border-white/10 transition-colors duration-300 bg-black" data-id="element-774">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12" data-id="element-775">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8 border-b border-white/20 pb-8" data-id="element-776">
          <div className="md:col-span-2" data-id="element-777">
            <Link to="/" className="inline-block mb-4" data-id="element-778">
              <Logo imgClassName="h-10 w-auto" invertOnLight={false} cycleEvery={3} data-id="element-779" />
            </Link>
            <p className="text-sm font-medium leading-relaxed max-w-sm text-[#ffffff]" data-id="element-780">
              {t('footer.tagline')}
            </p>
          </div>

          <div data-id="element-781">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-782">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-783">
              <li data-id="element-784">
                <a href="tel:206-619-3742" className="hover:text-white/70 transition-colors" data-id="element-785">
                  (206) 619-3742
                </a>
              </li>
              <li data-id="element-786">
                <a href="mailto:info@253gravel.com" className="hover:text-white/70 transition-colors" data-id="element-787">
                  info@253gravel.com
                </a>
              </li>
              <li data-id="element-788">Bonney Lake, WA</li>
            </ul>
          </div>

          <div data-id="element-789">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-790">
              {t('footer.hours')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-791">
              <li className="flex justify-between" data-id="element-792">
                <span data-id="element-793">{t('footer.monFri')}</span>
                <span data-id="element-794">6:00 AM – 5:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-795">
                <span data-id="element-796">{t('footer.saturday')}</span>
                <span data-id="element-797">7:00 AM – 3:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-798">
                <span data-id="element-799">{t('footer.sunday')}</span>
                <span data-id="element-800">{t('footer.closed')}</span>
              </li>
            </ul>
          </div>

          <div data-id="element-801">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-802">
              {t('footer.resources')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-803">
              <li data-id="element-804">
                <Link to="/compare" className="hover:text-white/70 transition-colors" data-id="element-805">
                  {t('nav.compareMaterials')}
                </Link>
              </li>
              <li data-id="element-806">
                <Link to="/delivery-prep" className="hover:text-white/70 transition-colors" data-id="element-807">
                  {t('footer.deliveryPrep')}
                </Link>
              </li>
              <li data-id="element-808">
                <Link to="/delivery-zones" className="hover:text-white/70 transition-colors" data-id="element-809">
                  {t('nav.deliveryZones')}
                </Link>
              </li>
              <li data-id="element-810">
                <Link to="/diy-help" className="hover:text-white/70 transition-colors" data-id="element-811">
                  {t('footer.diyGuide')}
                </Link>
              </li>
              <li data-id="element-812">
                <Link to="/help" className="hover:text-white/70 transition-colors" data-id="element-813">
                  {t('footer.materialQuiz')}
                </Link>
              </li>
              <li data-id="element-814">
                <Link to="/service-areas" className="hover:text-white/70 transition-colors" data-id="element-815">
                  Service Areas
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center text-sm font-medium text-white/60" data-id="element-816">
          <p data-id="element-817">
            &copy; {new Date().getFullYear()} 253Gravel. {t('footer.rights')}
          </p>
          <div className="mt-4 md:mt-0 space-x-6" data-id="element-818">
            <a href="#" className="hover:text-white transition-colors" data-id="element-819">
              {t('footer.privacy')}
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-820">
              {t('footer.terms')}
            </a>
          </div>
        </div>
      </div>
      <CredentialsBar data-id="element-821" />
    </footer>;
}